import { Component, OnInit } from '@angular/core';
import { ManufacturerService } from '../Services/manufacture.service';
import { Manufacturer } from "../objects/Manufacturer";
 
import { ActivatedRoute, Router } from '@angular/router'; 

@Component({
  selector: 'app-manufacturer-edit',
  templateUrl: './manufacturer-edit.component.html',
  styleUrls: ['./manufacturer-edit.component.css'],
})
export class ManufacturerEditComponent implements OnInit {
  manufacturer: Manufacturer = {
    id: 0,
    name: '',
    country: '',
  };

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private manufacturerService: ManufacturerService
  ) {}

  ngOnInit() {
    this.route.paramMap.subscribe((params) => {
      const manufacturerId = parseInt(params.get('id') || '0', 10);
      if (manufacturerId > 0) {
        this.loadManufacturer(manufacturerId);
      }
    });
  }

  loadManufacturer(manufacturerId: number) {
    this.manufacturerService.getManufacturerById(manufacturerId).subscribe((manufacturer) => {
      this.manufacturer = manufacturer;
    });
  }

  saveManufacturer() {
    this.manufacturerService.editManufacturer(this.manufacturer).subscribe((result) => {
      console.log('Manufacturer updated successfully!');
      this.router.navigate(['/manufacturers']);
    });
  }
}
